// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CONTEST_AMBASSADOR_TAG = "ambasadorka";
export const CONTEST_FINISHED_TAG = "sout\u011b\u017e ukon\u010den\u00e1";
